// Kolonne start from kipython kolonnen_start. Larger than the numbered stops.
export const START_MARKER_COLOR = "#D32F2F";

// Marker and route color per ISO weekday (1 = Monday ... 5 = Friday),
// shared between the AI-Ergebnis map (AiRouteMap.vue) and its legend
// (ProjectPlanningExport.vue). Both weeks of one KI result reuse these.
export const WEEKDAY_MARKER_COLORS = {
  1: "#5B4FCF", // Mo
  2: "#3B9FE0", // Di
  3: "#E0568C", // Mi
  4: "#F0A030", // Do
  5: "#7CB342"  // Fr
};

// Order matters here - it drives the legend's left-to-right Mo..Fr display.
export const WEEKDAY_LEGEND = [1, 2, 3, 4, 5];
